import {FC, ReactElement} from 'react'
import classNames from 'classnames'

type NoteMessageType = 'warning' | 'info' | 'error'

const NOTE_TYPE_CLASSES = {
  warning: 'border-yellow-100 bg-yellow-100',
  info: 'border-dope-cyan-bright bg-dope-cyan-100',
  error: 'border-red-400 bg-red-400',
}

interface NoteMessageWrapperProps {
  classes?: string
  children: ReactElement
  type?: NoteMessageType
}

export const NoteMessageWrapper: FC<NoteMessageWrapperProps> = ({
  classes,
  children,
  type = 'warning',
}) => {
  return (
    <div
      className={classNames(
        'p-3 flex items-center justify-center border bg-opacity-20',
        {
          [NOTE_TYPE_CLASSES.warning]: type === 'warning',
          [NOTE_TYPE_CLASSES.info]: type === 'info',
          [NOTE_TYPE_CLASSES.error]: type === 'error',
        },
        classes,
      )}
    >
      {children}
    </div>
  )
}
